var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Beautician Directory',"subtitle":'Edit Beautician Profile'}}),(_vm.beautician.id)?_c('beautician-form',{attrs:{"action":'edit',"beautician":_vm.beautician}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }